'use strict'
require('babel-polyfill')
// require('./add-touch-event.js');
// import 'objectFitPolyfill';

import Vue from 'vue'
import VueRouter from 'vue-router'
import vSelect from 'vue-select'

import App from './pages/app.vue'
import 'ress'
import colorJson from './color.json'

Vue.use(VueRouter)
Vue.component('v-select', vSelect)



const router = new VueRouter()


window.addEventListener('DOMContentLoaded', () => {
  const $body = document.querySelector('body')
  $body.classList.add('ready')

  Vue.filter('colorLabel', function(value) {
    if (!value) return ''
    const found = colorJson.colors.filter((item, index) => {
      return item.id === value
    })
    return found.length ? found[0].name.en : value
  })
  Vue.filter('year', function(date) {
    if (!date || !(date instanceof Date)) return ''
    return date.getFullYear()
  })
  Vue.filter('day', function(date) {
    if (!date || !(date instanceof Date)) return ''
    return date.getMonth() + 1 + '/' + date.getDate()
  })
  Vue.filter('utc', function(d) {
    if (!d) return ''
    const date = new Date(d)
    return date.getTime()
  })
  Vue.filter('shop_label', function(id) {
    if (!id) return ''
    const labels = {
      DAIKANYAMA: '代官山店',
      FUKUOKA: '福岡店',
    }
    return labels[id]
  })
  Vue.filter('shorten_date', function(date) {
    if (!date) return ''
    const d = new Date(date)
    return `${d.getMonth() + 1}/${d.getDate()} ${d.getHours()}:${("0"+d.getMinutes()).slice(-2)}`
  })

  Vue.filter('week', function(d) {
    const date = new Date(d)
    return [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ][date.getDay()]
  })

  Vue.filter('field_label', function(id) {
    if (!id) return ''
    const labels = {
      name: 'お名前',
      kana: 'ふりがな',
      address: 'ご住所',
      tel: 'お電話番号',
      email: 'メールアドレス',
      height: '身長',
      weight: '体重',
      width: 'お好みのサイズ感：横幅',
      length: 'お好みのサイズ感：着丈',
      measure: '計測方法',
      etc: 'その他ご要望',
    }
    return labels[id]
  })

  // Vue.filter('colorImage', function(selected, type) {
  //   if (!selected) return ''
  //   console.log(colorJson.colors[selected.front].back[selected.back], type)
  //
  //   if (type === 'front') {
  //     return colorJson.colors[selected.front][type]
  //   } else {
  //     return colorJson.colors[selected.front].back[selected.back]
  //   }
  // })

  const app = new Vue({
    router,
    data: () => {
      return {}
    },
    methods: {},
    // mounted: function() {
    //   console.log(this, this.$route, this.$router)
    // },
    render: h => h(App),
  }).$mount('#reservation')

  // $('a[href ^= "#"]').click(function(e){
  //   var $el = $($(this).attr('href'));
  //   scrollTo(calcScrollTo($el));
  //   closeModal();
  //   e.preventDefault();
  //   e.stopPropagation();
  // });
})
